export var IconName;
(function (IconName) {
    IconName["ALERT"] = "Alert";
    IconName["AMERICAN_EXPRESS"] = "American_express";
    IconName["ARROW_DOWN"] = "Arrow_down";
    IconName["ARROW_LEFT"] = "Arrow_left";
    IconName["ARROW_RIGHT"] = "Arrow_right";
    IconName["ARROW_UP"] = "Arrow_up";
    IconName["ARTIST"] = "Artist";
    IconName["AWARD"] = "Award";
    IconName["BLOCKCHAIN"] = "Blockchain";
    IconName["BOOK"] = "Book";
    IconName["CALENDAR"] = "calendar";
    IconName["CART"] = "Cart";
    IconName["CART_NAV"] = "Cart_nav";
    IconName["CHECKMARK"] = "Checkmark";
    IconName["CHECKMARK_OLD"] = "Checkmark_old";
    IconName["CHEVRON_DOWN"] = "Chevron_down";
    IconName["CHEVRON_LEFT"] = "Chevron_left";
    IconName["CHEVRON_RIGHT"] = "Chevron_right";
    IconName["CHEVRON_UP"] = "Chevron_up";
    IconName["CLOSE"] = "Close";
    IconName["CLOSE_BORDER"] = "Close_border";
    IconName["CLOSE_PROMO"] = "Close_promo";
    IconName["CLUB"] = "Club";
    IconName["COLLECTION"] = "Collection";
    IconName["COPY"] = "Copy";
    IconName["DATA"] = "Data";
    IconName["DIMENSIONS"] = "Dimensions";
    IconName["DISCORD"] = "Discord";
    IconName["DISCOVER"] = "Discover";
    IconName["DISPLATE_POSTER"] = "Displate_poster";
    IconName["EDITIONS"] = "Editions";
    IconName["EMPTY_CARD"] = "Empty_card";
    IconName["EMPTY_CARD_CVV"] = "Empty_card_cvv";
    IconName["ETHERSCAN"] = "Etherscan";
    IconName["FACEBOOK"] = "Facebook";
    IconName["FACEBOOK_CIRCLE"] = "Facebook_circle";
    IconName["FILE_TYPE"] = "File_type";
    IconName["FILTER"] = "Filter";
    IconName["FLAG"] = "Flag";
    IconName["GEAR"] = "Gear";
    IconName["GIFT"] = "Gift";
    IconName["HISTORY"] = "History";
    IconName["INDETERMINATE"] = "Indeterminate";
    IconName["INFO"] = "Info";
    IconName["INFO_WHITE"] = "Info_white";
    IconName["INFO_SOLID"] = "Info_solid";
    IconName["INFO_SOLID_BLUE"] = "Info_solid_blue";
    IconName["INSTAGRAM"] = "Instagram";
    IconName["INSTAGRAM_CIRCLE"] = "Instagram_circle";
    IconName["LINKEDIN_CIRCLE"] = "LinkedIn_circle";
    IconName["LOCK"] = "Lock";
    IconName["LOCK_UNLOCKED"] = "Lock_unlocked";
    IconName["LOGIN"] = "Login";
    IconName["LOGOUT"] = "Logout";
    IconName["MASTERCARD"] = "Mastercard";
    IconName["METAMASK"] = "Metamask";
    IconName["MEASURE"] = "Measure";
    IconName["MENU"] = "Menu";
    IconName["MORE"] = "more";
    IconName["NEW_TAB"] = "New_tab";
    IconName["PAYPAL"] = "Paypal";
    IconName["PICTURE_SKELETON"] = "Picture_skeleton";
    IconName["PINTEREST"] = "Pinterest";
    IconName["PINTEREST_CIRCLE"] = "Pinterest_circle";
    IconName["PLACEHOLDER"] = "Placeholder";
    IconName["PLANT"] = "Plant";
    IconName["PLAY"] = "Play";
    IconName["POINTER"] = "Pointer";
    IconName["PROMO_CODE"] = "Promo_code";
    IconName["QUESTIONMARK"] = "Questionmark";
    IconName["REDDIT"] = "Reddit";
    IconName["REFRESH"] = "Refresh";
    IconName["RESIZE"] = "Resize";
    IconName["SEARCH"] = "Search";
    IconName["DISPLATE_SEARCH_AUTOCOMPLETE"] = "Search_autocomplete";
    IconName["DISPLATE_SEARCH_INPUT"] = "Search_input";
    IconName["SERIAL_NUMBER"] = "Serial_number";
    IconName["SHARE"] = "Share";
    IconName["SORTER"] = "Sorter";
    IconName["SUCCESS"] = "Success";
    IconName["TREND"] = "Trend";
    IconName["TWITCH"] = "Twitch";
    IconName["TWITTER"] = "Twitter";
    IconName["TWITTER_CIRCLE"] = "Twitter_circle";
    IconName["UPLOAD"] = "Upload";
    IconName["USER_MENU"] = "User_menu";
    IconName["VISA"] = "Visa";
    IconName["VK"] = "VK";
    IconName["WALLET"] = "Wallet";
    IconName["WALLET_CONNECT"] = "Wallet_connect";
    IconName["WARNING"] = "Warning";
    IconName["WEBSITE"] = "Website";
    IconName["WISHLIST"] = "Wishlist";
    IconName["YOUTUBE"] = "Youtube";
})(IconName || (IconName = {}));
export var IconSize;
(function (IconSize) {
    IconSize["SIZE16"] = "16";
    IconSize["SIZE20"] = "20";
    IconSize["SIZE24"] = "24";
    IconSize["SIZE30"] = "30";
    IconSize["SIZE32"] = "32";
})(IconSize || (IconSize = {}));
//# sourceMappingURL=Icon.enum.js.map